import { Link } from 'react-router-dom';

function IconTelemetryTrace() {
  /* EKG-style polyline: flat baseline → sharp spike up → deep dip → recovery → small bump → flat
   * Viewbox 0-28 wide, 0-24 tall, centered vertically around y=14 */
  const points = '0,14 5,14 7,14 9,2 11,22 13,6 15,14 19,14 21,11 23,14 28,14';
  /* Generous dash length — must cover the full polyline so the draw-in reveals everything.
   * Actual geometric length ≈ 62; we overshoot to be safe. */
  const pathLength = 80;

  return (
    <svg
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="sidebar-brand-trace"
      aria-hidden="true"
    >
      <polyline
        points={points}
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        strokeDasharray={pathLength}
        strokeDashoffset={pathLength}
        className="sidebar-brand-trace-line"
      />
    </svg>
  );
}

export function SidebarBrand({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="sidebar-brand">
      <Link
        to="/"
        className="sidebar-brand-link"
        aria-label="F1 at Forked — go to home"
        onClick={onNavigate}
      >
        <IconTelemetryTrace />
        <span className="sidebar-brand-text">
          <span className="sidebar-brand-f1">F1</span>
          <span className="sidebar-brand-at-forked">at Forked</span>
        </span>
      </Link>
    </div>
  );
}
